import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const ChannelListSynopsisMainContainer = styled.div<React.CSSProperties>`
  display: flex;
  overflow: hidden;
  position: relative;
  height: ${500 * Screen.widthRatio}px;
  margin-top: ${10 * Screen.widthRatio}px;
`;

export default ChannelListSynopsisMainContainer;
